import React from 'react';

import { NarrowSelect } from '../styled';
import { Field } from 'shared/containers/form';
import styled from 'styled-components';

const options = [
  { label: '--select--', value: '' },
  { label: 'He/him', value: 'He/him' },
  { label: 'She/her', value: 'She/her' },
  { label: 'They/them', value: 'They/them' },
  { label: 'Prefer not to share', value: 'Prefer not to share' },
  { label: 'other', value: 'other' },
];

const StyledField = styled(Field)`
  & .MuiSelect-root {
    padding-top: 14.5px;
    padding-bottom: 14.5px;
  }
`;

interface PronounSelectProps {
  disabled?: boolean;
  fullWidth?: boolean;
}

const PronounSelect: React.FC<PronounSelectProps> = ({ disabled = false, fullWidth }) => {
  return (
    <StyledField
      placeholder="Pronoun"
      name="custom:pronoun"
      component={NarrowSelect}
      disabled={disabled}
      options={options}
      maxWidth={undefined}
      label={undefined}
      required={undefined}
      useFormControl={undefined}
      onChange={undefined}
      fullWidth={fullWidth}
    />
  );
};

export default PronounSelect;
